import { createClient, SupabaseClientOptions } from '@supabase/supabase-js';
import type { Database } from '../types/supabase';

// These environment variables are required
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Add this to your existing supabase configuration
const supabaseConfig: SupabaseClientOptions<'public'> = {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  global: {
    fetch: (input, init) => {
      if (init?.signal) return fetch(input, init);
      return fetch(input, { ...init, signal: AbortSignal.timeout(15000) });
    },
  },
};

export const supabase = createClient<Database>(
  supabaseUrl,
  supabaseAnonKey,
  supabaseConfig
);